/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { loginAsRequestV4Schema } from './loginAsRequestV4Schema'
import { loginAsResponseV4ApiResponseObjectV4Schema } from './loginAsResponseV4ApiResponseObjectV4Schema'

export const edyAllUsersLoginAsPathIdSchema = z
  .string()
  .describe("The target user's coded id.")
  .meta({ examples: ['kJ8v2Qm7xR1a'] })

export const edyAllUsersLoginAsStatus200Schema =
  loginAsResponseV4ApiResponseObjectV4Schema.describe(
    'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
  )

export const edyAllUsersLoginAsStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const edyAllUsersLoginAsStatus404Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const edyAllUsersLoginAsResponseSchema = edyAllUsersLoginAsStatus200Schema

export const edyAllUsersLoginAsErrorSchema = z.union([
  edyAllUsersLoginAsStatus400Schema,
  edyAllUsersLoginAsStatus404Schema,
])

export const edyAllUsersLoginAsBodySchemaJsonPatchJson = loginAsRequestV4Schema
  .optional()
  .describe('The support case number (required).')

export const edyAllUsersLoginAsBodySchemaJson = loginAsRequestV4Schema
  .optional()
  .describe('The support case number (required).')

export const edyAllUsersLoginAsBodySchemaJson2 = loginAsRequestV4Schema
  .optional()
  .describe('The support case number (required).')

export const edyAllUsersLoginAsBodySchemaJson3 = loginAsRequestV4Schema
  .optional()
  .describe('The support case number (required).')

export const edyAllUsersLoginAsBodySchema = z.union([
  edyAllUsersLoginAsBodySchemaJsonPatchJson,
  edyAllUsersLoginAsBodySchemaJson,
  edyAllUsersLoginAsBodySchemaJson2,
  edyAllUsersLoginAsBodySchemaJson3,
])
